/*
 * Short beacon redirect — /b/:code
 * Resolves the branded short code to the real beacon_key, then hands off to
 * the full DriverBeacon page. Exists purely so SMS/QR links are short and
 * clean instead of exposing the 32-char beacon_key everywhere.
 */
import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/tpt/b`;

export default function BeaconShortLink() {
  const { code } = useParams();
  const [beaconKey, setBeaconKey] = useState(undefined); // undefined=loading, null=not found, string=ok

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/${code}`)
      .then((r) => { if (alive) setBeaconKey(r.data.beacon_key); })
      .catch(() => { if (alive) setBeaconKey(null); });
    return () => { alive = false; };
  }, [code]);

  if (beaconKey === undefined) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#0B1220", color: "#fff", fontFamily: "Manrope, sans-serif" }} data-testid="beacon-short-link-loading">
        Opening your beacon…
      </div>
    );
  }
  if (beaconKey === null) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, textAlign: "center", fontFamily: "Manrope, sans-serif" }} data-testid="beacon-short-link-not-found">
        <div>
          <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 8 }}>Link not found</div>
          <div style={{ fontSize: 13, color: "#64748B" }}>This beacon link may have expired or is invalid. Ask dispatch to resend it.</div>
        </div>
      </div>
    );
  }
  return <Navigate to={`/beacon/${beaconKey}`} replace />;
}
